import {AuditExportFormat} from './audit-log';

export enum RecallAuditEventType {
    RECALL_BY_PRODUCT_ADMIN = 'RECALL_BY_PRODUCT_ADMIN',
    RECALL_BY_PRODUCT_BATCH_ADMIN = 'RECALL_BY_PRODUCT_BATCH_ADMIN',
    RECALL_BY_PRODUCT_BATCH_OWNER = 'RECALL_BY_PRODUCT_BATCH_OWNER',
}

export interface RecallAuditEntry {
    eventId: string;
    eventType: RecallAuditEventType;
    eventTimestamp: string;
    userId: string;
    userFullName: string;
    userRole: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    productCode?: string;
    batchNumber?: string;
    batchId?: number;
    productionDate?: string;
    reasonCode?: string;
    reason?: string;
    regulatorDocumentNumber?: string;
    recallDecisionDate?: string;
    comment?: string;
    affectedCodesCount?: number;
    affectedOrganizations?: RecallAuditAffectedOrganization[];
    previousStatuses?: RecallAuditPreviousStatus[];
    createdAt?: string;
}

export interface RecallAuditAffectedOrganization {
    organizationId?: number;
    codesCount?: number;
    clientIds?: number[];
}

export interface RecallAuditPreviousStatus {
    status?: string;
    count?: number;
}

export interface RecallAuditPage {
    data: RecallAuditEntry[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export interface RecallAuditFilters {
    userId?: string;
    userFullName?: string;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    eventType?: RecallAuditEventType;
    from?: string;
    to?: string;
    productCode?: string;
    batchNumber?: string;
    batchId?: number;
    reasonCode?: string;
    regulatorDocumentNumber?: string;
}

export interface RecallAuditListParams extends RecallAuditFilters {
    page?: number;
    size?: number;
}

export interface RecallAuditExportParams extends Omit<RecallAuditFilters, 'from' | 'to'> {
    from: string;
    to: string;
    page?: number;
    size?: number;
    format: AuditExportFormat;
}

export interface RecallAuditExportResult {
    data: Blob;
    truncated: boolean;
    limit?: number;
}

export enum RecallAuditAccessors {
    eventId = 'eventId',
    batchId = 'batchId',
    eventType = 'eventType',
    organizationName = 'organizationName',
    organizationTin = 'organizationTin',
    eventTimestamp = 'eventTimestamp',
    userFullName = 'userFullName',
    userRole = 'userRole',
}
